import instance from '@/services/repository';

const resource = '/rawmaterials';

export default {
    get() {
        return instance.get(`${resource}`);
    },
    getUsage(id: string) {
        return instance.get(`${resource}/${id}/usage`);
    },
    create(payload: any) {
        return instance.post(`${resource}`, payload);
    },
    copy(id: string) {
        return instance.post(`${resource}/copy/${id}`);
    },
    update(payload: any) {
        payload.defaultPrice = null;
        return instance.put(`${resource}/${payload.id}`, payload);
    },
    delete(payload: any) {
        return instance.delete(`${resource}/${payload.id}`);
    },
};
